import * as Urls from 'lib/urls'
import fetch from 'lib/fetch'

export const getPurchaseReturnLink = (data) => {
  return fetch(Urls.apiV3PurchaseReturnsPath, {
    body: JSON.stringify(data),
    method: 'POST',
  })
}
